import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getEvents } from '../../../selectors/events';
import { getLeagues, getMarkets, getOddsHistoryTemplate } from '../../../selectors/common';
import { getMatchId } from '../../../selectors/oddsHistory';
import {
  PAGES,
} from '../../../constants';
import { getEventDetails, getMatchTimeline } from '../../../selectors/matchTimeline';
import OddsHistory1 from '..';
import { aGetMatchTimelineRequest } from '../../../reducers';
import { aSetSelectedRowMatchId } from '../../../reducers/oddsHistory';

const mapToProps = (state) => ({
  events: getEvents(state),
  leagues: getLeagues(state),
  markets: getMarkets(state),
  matchId: getMatchId(state),
  eventDetails: getEventDetails(state),
  matchTimeline: getMatchTimeline(state),
  oddsHistoryTemplate: getOddsHistoryTemplate(state),
});

const actionsToProps = (dispatch) => ({
  getMatchTimeline: (payload) => dispatch(aGetMatchTimelineRequest(payload)),
  setSelectedRowMatchId: (payload) => dispatch(aSetSelectedRowMatchId(payload)),
});


const SoccerOddsHistory1 = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(()=>{
    const { pathname } = location;
    const matchId = parseInt(props.matchId || (pathname.split(`${PAGES.ODDS_HISTORY_STEP_1}/`)[1]));
    if (matchId) {
      props.getMatchTimeline({
        matchId,
      });
      props.setSelectedRowMatchId({
        selectedRowMatchId: matchId,
      });
    }
  // eslint-disable-next-line
  }, []);

  return (
    <OddsHistory1
      navigate={navigate}
      eventDetails={props.eventDetails}
      oddsStep1Page={PAGES.ODDS_HISTORY_STEP_1}
      oddsStep2Page={PAGES.ODDS_HISTORY_STEP_2}
      oddsHistoryTemplate={props.oddsHistoryTemplate}
      matchTimeline={props.matchTimeline}
      matchId={props.matchId}
      leagues={props.leagues}
    />
  );
};

export default connect(mapToProps, actionsToProps)(SoccerOddsHistory1);
